var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _vm._l(_vm.schema, function(sch, key) {
        return [
          sch.type == "object"
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "text-xs-right", attrs: { xs3: "" } },
                    [_vm._v(_vm._s(sch.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs9: "" } },
                    [
                      _c("form-schema-field-collection", {
                        attrs: {
                          value: _vm.internalValue[key],
                          schema: sch.properties,
                          "required-keys": sch.required,
                          disabled: _vm.disabled
                        },
                        on: {
                          input: function($event) {
                            return _vm.setValue(key, $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : sch.type == "array"
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "text-xs-right", attrs: { xs3: "" } },
                    [_vm._v(_vm._s(sch.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs9: "" } },
                    [
                      _vm._l(_vm.internalValue[key], function(val, index) {
                        return _c(
                          "div",
                          { staticClass: "field-collection-container" },
                          [
                            sch.items.type == "object"
                              ? _c("form-schema-field-collection", {
                                  attrs: {
                                    value: _vm.internalValue[key][index],
                                    schema: sch.items,
                                    "required-keys": sch.required,
                                    disabled: _vm.disabled
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.setValue(key, $event, index)
                                    }
                                  }
                                })
                              : _c("form-schema-field", {
                                  attrs: {
                                    value: _vm.internalValue[key][index],
                                    schema: sch.items,
                                    required: _vm.isRequired(key),
                                    disabled: _vm.disabled
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.setValue(key, $event, index)
                                    }
                                  }
                                }),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "field-collection-delete",
                                attrs: {
                                  flat: "",
                                  small: "",
                                  color: "primary",
                                  disabled: _vm.disabled
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteItem(key, index)
                                  }
                                }
                              },
                              [
                                _c("v-icon", [_vm._v("delete")]),
                                _vm._v(" delete")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            small: "",
                            color: "primary",
                            disabled: _vm.disabled
                          },
                          on: {
                            click: function($event) {
                              return _vm.addItem(key)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("add")]), _vm._v(" add")],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _c("form-schema-field", {
                attrs: {
                  value: _vm.internalValue[key],
                  required: _vm.isRequired(key),
                  schema: sch,
                  disabled: _vm.disabled
                },
                on: {
                  input: function($event) {
                    return _vm.setValue(key, $event)
                  }
                }
              })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2769791a", { render: render, staticRenderFns: staticRenderFns })
  }
}